/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

Shopify.Cart = Shopify.Cart || {};

Shopify.Cart.GiftOrder = {};

Shopify.Cart.GiftOrder.set = function() {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js', 
    data: { attributes: { 'gift-order': true } }, 
    dataType: 'json',
    success: function() { jQuery(".gift-message-p").show(); }
  });
}

Shopify.Cart.GiftOrder.remove = function() {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js', 
    data: { attributes: { 'gift-order': '','gift-message': '' } },
    dataType: 'json',
    success: function() { jQuery(".gift-message-p").hide(); jQuery('[name="attributes\[gift-message\]"]').val("");}
  });
}  

Shopify.Cart.GiftOrder.noteset = function(note) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js', 
    data: { attributes: { 'gift-message': note } }, 
    dataType: 'json'
  });
}
  
jQuery(function() {
  jQuery('[name="attributes\[gift-order\]"]').change(function() {
    if (jQuery(this).is(':checked')) {
      Shopify.Cart.GiftOrder.set();    
    }
    else {
      Shopify.Cart.GiftOrder.remove();
    }
  });
  
  jQuery('[name="attributes\[gift-message\]"]').change(function() {
    Shopify.Cart.GiftOrder.noteset(jQuery(this).val());
  });    
});